import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'objectkey' })
export class ColorsKeysPipe implements PipeTransform {
    transform(value, args: string): any {
    
        if (value && value.length > 0) {
            let match = _.find(value, { statusId: args });
            
            return match && match != undefined ? match.statusColor : '';

        }
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/objectKey.pipe.ts